import dotProp from 'dot-prop-immutable';

export const setupNewPostURL = (params = {}, link) => {
  return dotProp.set(params, 'newEndPoint', link);
};

export const hasNewPostLink = (param, defaultURL = '') => {
  return dotProp.get(param, 'newEndPoint', defaultURL);
};
